<template>
  <section class="stock-information">
    <p v-if="loading" role="status">加载中…</p>
    <p v-else-if="error" role="alert">{{ error }} <button type="button" @click="load">重试</button></p>
    <template v-else-if="tab === 'news'">
      <button v-for="item in news" :key="item.id" class="stock-news-row" type="button" @click="openNews(item)"><span>{{ item.title }}</span><small>{{ item.source || '' }} <time>{{ item.time || '' }}</time></small></button>
      <p v-if="!news.length">暂无新闻</p>
    </template>
    <template v-else>
      <section v-for="section in sections" :key="section.title" class="stock-profile-section"><header>{{ section.title }}<small>{{ section.date || '' }}</small></header><dl><template v-for="field in section.rows"><dt :key="field[0] + '-label'">{{ field[0] }}</dt><dd :key="field[0]">{{ field[1] }}</dd></template></dl></section>
      <p v-if="!sections.length">暂无简况</p>
    </template>
    <el-dialog :title="article.title || '新闻详情'" :visible.sync="articleVisible" width="min(800px, 92vw)" top="6vh" append-to-body custom-class="stock-news-dialog" @close="detailRequest++">
      <p v-if="articleLoading">加载中…</p><p v-else-if="articleError" role="alert">{{ articleError }} <button type="button" @click="openNews(articleItem)">重试</button></p>
      <article v-else class="stock-news-content"><template v-for="(block,index) in articleBlocks"><img v-if="block.type === 'image'" :key="index" :src="image(block.url)" alt="新闻配图" @error="hideImage"><p v-else :key="index">{{ block.text }}</p></template><p v-if="!articleBlocks.length">暂无正文</p></article>
    </el-dialog>
  </section>
</template>
<script>
import request from '@/utils/request'
import { stockSelection } from './stockSelection'
import { newsContentBlocks, newsImageUrl } from '@/views/consult/newsContent'
export default {
  props: { market: String, symbol: String, tab: String },
  data: () => ({ news: [], profile: null, loading: false, error: '', sequence: 0, articleVisible: false, article: {}, articleItem: {}, articleLoading: false, articleError: '', detailRequest: 0 }),
  computed: {
    stock() { return stockSelection({ market: this.market, symbol: this.symbol }) },
    context() { return this.market + ':' + this.symbol },
    articleBlocks() { return newsContentBlocks(this.article.content) },
    sections() {
      const profile = this.profile || {}, sections = []
      // Profile APIs already provide H5-ready financial/share-capital values.
      // Preserve supplied scale/unit strings rather than applying Tencent quote units.
      const add = (title, source, fields, date) => {
        const rows = fields.map(([key,label]) => [label, source && source[key]]).filter(row => row[1] != null && row[1] !== '' && typeof row[1] !== 'object')
        if (rows.length) sections.push({ title, rows, date })
      }
      if (profile.zyzb) add('主要指标', profile.zyzb.detail, [['syl','市盈TTM'],['sjl','市净率'],['mgsy','每股收益'],['mgjzc','每股净资产'],['jzcsyl','净资产收益率'],['zcfzl','资产负债率'],['yyzsr','营业总收入'],['zsrzzl','营收同比'],['jlr','净利润'],['jlrzzl','净利润同比'],['sy_jzc','商誉/净资产']], profile.zyzb.date)
      if (this.market === 'cn') {
        add('公司简介', profile.gsjj, [['gsmz','公司名称'],['riqi','上市日期'],['jg','发行价格'],['dy','地区'],['yw','主营业务']])
        const company = profile.gsjj || {}
        add('所属板块', Object.fromEntries(['plate','concept','area'].map(key => [key, (company[key] || []).map(item => item.name).join('、')])), [['plate','行业'],['concept','概念'],['area','地域']])
      } else if (this.market === 'hk') {
        add('公司简况', profile.basic, [['ChiName','公司名称'],['ListedDate','上市日期'],['Chairman','集团主席'],['Website','公司网址'],['STOCK_SUM','总股本'],['HK_STOCK_SUM','港股股本'],['Business','主营业务'],['BriefIntroduction','公司简介']])
      } else {
        const basic = profile.jbxx || {}
        add('公司简况', { ...basic, industryName: (basic.industry || {}).name }, [['gsmc','公司名称'],['ssrq','上市日期'],['jys','交易所'],['industryName','所属板块'],['website','公司网址'],['zgb','总股本'],['jianjie','公司简介']])
        const revenue = (profile.srgc || [])[0]
        if (revenue) add('主营收入', Object.fromEntries((revenue.detail || []).map(row => [row.label, `${row.sales || '--'} ${row.zb || ''}`])), (revenue.detail || []).map(row => [row.label,row.label]), revenue.date)
      }
      return sections
    }
  },
  watch: {
    context() { this.profile = null; this.news = []; this.articleVisible = false; this.detailRequest++; this.load() },
    tab() { this.articleVisible = false; this.detailRequest++; this.load() }
  },
  mounted() { this.load() },
  beforeDestroy() { this.sequence++; this.detailRequest++ },
  methods: {
    image: newsImageUrl,
    hideImage(event) { event.target.style.display = 'none' },
    async load() {
      const sequence = ++this.sequence, code = this.market === 'cn' ? this.stock.symbol : this.stock.code
      if (!code) { this.loading = false; this.news = []; this.profile = null; this.error = '请先选择股票'; return }
      this.loading = true; this.error = ''; this.news = []
      try {
        let profile = this.profile
        if (this.tab === 'profile' || (this.market === 'us' && !profile)) {
          profile = await request({ url: 'vexe/v1/stock/' + (this.market === 'cn' ? 'introduction' : 'gMIntroduction'), method: 'get', params: { code } })
          if (sequence !== this.sequence) return
          if (!profile || typeof profile !== 'object' || Array.isArray(profile)) throw Error('invalid profile')
          this.profile = profile
        }
        if (this.tab === 'news') {
          let newsCode = code
          if (this.market === 'hk') newsCode = '116.' + code.slice(2)
          if (this.market === 'us') {
            const exchange = ((profile || {}).jbxx || {}).jys
            if (!exchange) throw Error('无法确认该美股交易所，请稍后重试')
            newsCode = (/纳斯达克|nasdaq/i.test(exchange) ? '105.' : '106.') + code.slice(2)
          }
          const rows = await request({ url: 'vexe/v1/stock/' + (this.market === 'cn' ? 'newsList' : 'gmNewsList'), method: 'get', params: { code: newsCode } })
          if (sequence !== this.sequence) return
          if (!Array.isArray(rows)) throw Error('invalid news')
          this.news = rows
        }
      } catch (_) { if (sequence === this.sequence) this.error = this.tab === 'news' ? '新闻加载失败，请重试' : '简况加载失败，请重试' }
      finally { if (sequence === this.sequence) this.loading = false }
    },
    async openNews(item) {
      const sequence = ++this.detailRequest
      this.articleItem = item; this.article = { title: item.title }; this.articleVisible = true; this.articleLoading = true; this.articleError = ''
      try {
        const detail = await request({ url: 'vexe/v1/news/detail', method: 'get', params: { id: item.id, type: 2 } })
        if (sequence !== this.detailRequest) return
        if (!detail || typeof detail !== 'object') throw Error('invalid detail')
        this.article = { ...item, ...detail }
      } catch (_) { if (sequence === this.detailRequest) this.articleError = '新闻详情加载失败，请重试' }
      finally { if (sequence === this.detailRequest) this.articleLoading = false }
    }
  }
}
</script>
<style scoped>
.stock-information { flex: 1; min-height: 0; overflow: auto; padding: 8px 16px; color: var(--theme-label); }
.stock-information > p { padding: 20px 0; text-align: center; color: var(--theme-muted); }
button { font: inherit; color: inherit; cursor: pointer; }
.stock-news-row { width: 100%; display: block; padding: 12px 0; text-align: left; border: 0; border-bottom: 1px solid var(--theme-border); background: transparent; }
.stock-news-row:hover { color: var(--theme-accent); }
.stock-news-row small { display: flex; justify-content: space-between; margin-top: 8px; color: var(--theme-muted); }
.stock-profile-section { padding: 12px 0; border-bottom: 1px solid var(--theme-border); }
.stock-profile-section header { display: flex; justify-content: space-between; font-size: 15px; }
.stock-profile-section small { font-size: 12px; color: var(--theme-muted); }
dl { display: grid; grid-template-columns: minmax(95px, auto) 1fr; gap: 10px 16px; margin: 14px 0 0; font-size: 13px; }
dt { color: var(--theme-muted); } dd { margin: 0; white-space: pre-wrap; overflow-wrap: anywhere; }
.stock-news-content { color: var(--theme-label); overflow-wrap: anywhere; }
.stock-news-content p { white-space: pre-wrap; line-height: 1.8; } .stock-news-content img { max-width: 100%; height: auto; }
</style>
<style>
html[data-theme] .stock-news-dialog { display: flex; flex-direction: column; max-height: 88vh; margin-bottom: 0; overflow: hidden; }
html[data-theme] .stock-news-dialog .el-dialog__header { flex: none; padding-right: 48px; }
html[data-theme] .stock-news-dialog .el-dialog__title { white-space: normal; overflow-wrap: anywhere; line-height: 1.5; }
html[data-theme] .stock-news-dialog .el-dialog__body { min-height: 0; height: auto !important; flex: 1; overflow-y: auto; overflow-x: hidden; padding: 16px 24px; overscroll-behavior: contain; scrollbar-width: thin; }
</style>
